module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "-10px",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('div', {
    staticClass: "find"
  }, [_c('el-form', {
    staticClass: "demo-form-inline findform",
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "height": "55px",
      "margin-left": "-10px"
    },
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    staticClass: "demo-item",
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "品牌选择："
    }
  }, [_c('el-select', {
    staticClass: "demo-select",
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.brandId),
      callback: function($$v) {
        _vm.brandId = $$v
      },
      expression: "brandId"
    }
  }, _vm._l((_vm.pinpaiptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "demo-item",
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "商品分类："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "options": _vm.options1,
      "filterable": "",
      "change-on-select": ""
    },
    on: {
      "change": _vm.handleChange1
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "销售类型："
    }
  }, [_c('el-select', {
    staticClass: "demo-select",
    attrs: {
      "placeholder": "请选择销售类型"
    },
    model: {
      value: (_vm.showtype),
      callback: function($$v) {
        _vm.showtype = $$v
      },
      expression: "showtype"
    }
  }, _vm._l((_vm.moretype), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline2 findform",
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "height": "55px",
      "margin-left": "-10px"
    },
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    staticClass: "demo-item",
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "商品类型："
    }
  }, [_c('el-select', {
    staticClass: "demo-select",
    attrs: {
      "placeholder": "请选择商品类型"
    },
    model: {
      value: (_vm.CommodityId),
      callback: function($$v) {
        _vm.CommodityId = $$v
      },
      expression: "  CommodityId"
    }
  }, _vm._l((_vm.Commoditytypes), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "所属城市："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.options,
      "filterable": "",
      "change-on-select": ""
    },
    on: {
      "change": _vm.handleChange
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "商品名称："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入查询商品名称"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "float": "right",
      "margin-right": "10px"
    }
  }, [_c('el-button', {
    staticClass: "Establish",
    on: {
      "click": function($event) {
        _vm.Search()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticClass: "Reset",
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("重置")])], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    class: _vm.show3 ? 'banner_table' : 'banner_table1'
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shopshow),
      expression: "shopshow"
    }],
    staticClass: "noshop"
  }, [_vm._v("请搜索添加商品")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableshow),
      expression: "tableshow"
    }]
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "20px",
      "height": "auto"
    },
    attrs: {
      "data": _vm.tableData6,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "align": "center",
      "label": "选择",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          on: {
            "change": function($event) {
              return _vm.sure(scope)
            }
          },
          model: {
            value: (scope.row.Id),
            callback: function($$v) {
              _vm.$set(scope.row, "Id", $$v)
            },
            expression: "scope.row.Id"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "align": "center",
      "label": "主图/商品名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "50px",
            "height": "50px",
            "float": "left",
            "margin-left": "10px"
          },
          attrs: {
            "data-img": scope.row.FImgs,
            "src": scope.row.FImgs
          },
          on: {
            "click": _vm.$imgPreview
          }
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "display": "inline-block",
            "float": "left",
            "margin": "10px 0 0 5px"
          }
        }, [_vm._v(_vm._s(scope.row.Title))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "GoodModelCode",
      "align": "center",
      "label": "商品编码"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.GoodModelCode
          }
        }, [_vm._v(_vm._s(scope.row.GoodModelCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount2",
      "align": "center",
      "label": "所属城市"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.ProvinceName + '-' + scope.row.CityName
          }
        }, [_vm._v(_vm._s(scope.row.ProvinceName) + "-" + _vm._s(scope.row.CityName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "TzrPrice",
      "align": "center",
      "label": "销售价格（元）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": '￥' + scope.row.TzrPrice
          }
        }, [_vm._v("￥" + _vm._s(scope.row.TzrPrice))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "allchecked"
  }, [_c('span', {
    staticStyle: {
      "margin-top": "10px",
      "margin-left": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.allsure()
      }
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("\r\n            全选 (\r\n            "), _c('span', [_vm._v(_vm._s(_vm.jLength))]), _vm._v("\r\n            / " + _vm._s(_vm.tableData6.length) + " )\r\n          ")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "addgoods",
    on: {
      "click": function($event) {
        return _vm.addgoods()
      }
    }
  }, [_vm._v("添加")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "150px"
    },
    attrs: {
      "title": _vm.Searchorreset ? '重置提示' : '错误提示',
      "visible": _vm.dialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Searchorreset ? "是否重置所有的搜索项" : "请选择搜索条件查询"))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "findEr",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.Whether()
      }
    }
  }, [_vm._v(_vm._s(_vm.Searchorreset ? "是" : "确定"))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Searchorreset),
      expression: "Searchorreset"
    }],
    staticClass: "findEr1",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("否")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "150px"
    },
    attrs: {
      "title": _vm.isAdd ? '添加成功提示' : '错误提示',
      "visible": _vm.dialogVisibleadd,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleadd = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.isAdd ? "添加成功" : "添加内容为空"))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "findEr",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisibleadd = false
      }
    }
  }, [_vm._v(_vm._s(_vm.isAdd ? "确定" : "返回"))])], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "goodslist1",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "37px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "goods_red"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("商品管理")]), _vm._v(" "), _c('span', {
    staticClass: "goods_red"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0da669e5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/markegoods.vue
// module id = 1633
// module chunks = 3